import 'ui-theme/components/sections-navbar/js/sections-navbar';
(function () {
    let sidebarSections = UX.sidebarSections;
    sidebarSections.initSections = function () {
        //if theres is sections then show section word & initialize it
        $('.sections-block-container').removeClass('not-visible');
        $('.article-navigation-items-separator').removeClass('not-visible');

        let articleSections = document.querySelectorAll('.hlFld-Fulltext > .article-section');
        if (articleSections.length > 0) {
            let list = '';
            articleSections.forEach(section => {
                list += '<li>';
                list += '<ul class="rlist">';
                function listFunc(sectionName, level) {
                    let listItems = sectionName.querySelectorAll(':scope > .article-section__title');
                    listItems.forEach(element => {
                        list +=
                            '<li><a title="' +
                            element.textContent +
                            '" href="#' +
                            element.id +
                            '" class=list-level_' +
                            level +
                            '>' +
                            element.textContent +
                            '</a></li>';
                    });
                    let subSection = sectionName.querySelector(':scope > .article-section');
                    if (subSection) {
                        list += '<li>';
                        list += '<ul class="rlist sections-block__nested-list">';
                        listFunc(subSection, subSection.dataset?.level);
                        list += '</li>';
                        list += '</ul>';
                    } else {
                        list += '</li>';
                        list += '</ul>';
                    }
                }
                listFunc(section, 1);
            });
            if (list !== '') {
                sidebarSections.$block.append(list);
            }
        } else {
            $(sidebarSections.$scrollPoints.get().reverse()).each(function () {
                sidebarSections.$block.prepend(sidebarSections.get.htmlSection($(this)));
            });
        }

        $('.actionsbar__has__sections .sections-block-container').css({
            'max-height': 'calc(100vh - " +$("header").height()+ "px)',
        });
    };
})();
